module.exports = __webpack_public_path__ + "static/1-583e15000fd7d0be2cfb825e8f50cc4b.jpg";